module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG15f060fe8034094d646d112b5e6f51a8.15f060fe.png";